export type SetupPlatformId = 'android' | 'ios' | 'windows' | 'macos';

export const detectPlatform = (userAgent: string): SetupPlatformId => {
  if (/android/i.test(userAgent)) return 'android';
  if (/iphone|ipad|ipod/i.test(userAgent)) return 'ios';
  if (/windows/i.test(userAgent)) return 'windows';
  if (/macintosh|mac os x/i.test(userAgent)) return 'macos';
  return 'android';
};
